import { BankATMScreen } from "@/domains/bank/components/BankATM/types";
import { Deposit2Icon } from "@/domains/bank/components/Icons/Deposit2Icon";
import { Phone2Icon } from "@/domains/bank/components/Icons/Phone2Icon";
import { Transfer2Icon } from "@/domains/bank/components/Icons/Transfer2Icon";
import { Withdraw2Icon } from "@/domains/bank/components/Icons/Withdraw2Icon";

function NavButton({
  children,
  onClick,
  Icon,
}: {
  children: React.ReactNode;
  onClick: () => void;
  Icon: React.ComponentType<{ className?: string }>;
}) {
  return (
    <button
      type="button"
      className="relative flex flex-col items-start justify-start bg-white font-bold rounded-2xl p-5 px-7 shadow-sbank-control hover:shadow-sbank-control-hover transition-all duration-200 cursor-pointer"
      onClick={onClick}
    >
      {children}

      <div className="absolute right-5 top-5 size-10">
        <Icon className="absolute z-1 top-0 right-0" />
        <Icon className="absolute z-0 top-3.5 right-2.5 blur-[2px] opacity-15 " />
      </div>
    </button>
  );
}

function TariffInfoCard({ title, value }: { title: string; value: number }) {
  return (
    <div className="flex flex-col justify-between rounded-2xl border border-sbank-muted/20 p-4 w-full">
      <div className="text-15 font-medium leading-tight text-dark-800">{title}</div>
      <div className="text-15 font-bold leading-tight text-green-800 bg-green-700/10 rounded-xl px-2 py-1 w-fit">
        {value}%
      </div>
    </div>
  );
}

export function BankATMHomeScreen({
  onScreenChange,
  tariffName,
  withdrawalFeePercent,
  transferFeePercent,
}: {
  onScreenChange: (screen: BankATMScreen) => void;
  tariffName: string;
  withdrawalFeePercent: number;
  transferFeePercent: number;
}) {
  return (
    <>
      <div className="grid grid-cols-[275px_1fr] gap-8 h-[205px]">
        <div className="flex flex-col">
          <p className="mb-5 text-15 font-normal leading-tight text-sbank-muted">
            При работе через банкомат может взиматься комиссия:
          </p>

          <div className="flex gap-3 h-full">
            <TariffInfoCard title="Пополнение средств" value={transferFeePercent} />
            <TariffInfoCard title="Снятие средств" value={withdrawalFeePercent} />
          </div>
        </div>

        {/* Control buttons grid */}
        <div className="grid grid-cols-2 grid-rows-2 gap-3">
          <NavButton onClick={() => onScreenChange(BankATMScreen.Withdraw)} Icon={Withdraw2Icon}>
            Снять
          </NavButton>

          <NavButton onClick={() => onScreenChange(BankATMScreen.Deposit)} Icon={Deposit2Icon}>
            Внести
          </NavButton>

          <NavButton onClick={() => onScreenChange(BankATMScreen.Transfer)} Icon={Transfer2Icon}>
            Перевести
          </NavButton>

          <NavButton onClick={() => onScreenChange(BankATMScreen.PhoneTopUp)} Icon={Phone2Icon}>
            <span>Пополнить</span>
            <span>телефон</span>
          </NavButton>
        </div>
      </div>

      <div className="mt-8">
        <div className="font-bold text-18 text-dark-800 leading-loose">{tariffName} тариф</div>
        <p className="text-15 font-normal leading-tight text-sbank-muted">
          Для смены тарифного плана банковского счета отправляйтесь в ближайшее отделение банка
          СБАНК.
        </p>
      </div>
    </>
  );
}
